import { render, staticRenderFns } from "./ContactPane.vue?vue&type=template&id=0a7ac3e8&scoped=true"
import script from "./ContactPane.vue?vue&type=script&lang=js"
export * from "./ContactPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ac3e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a7ac3e8')) {
      api.createRecord('0a7ac3e8', component.options)
    } else {
      api.reload('0a7ac3e8', component.options)
    }
    module.hot.accept("./ContactPane.vue?vue&type=template&id=0a7ac3e8&scoped=true", function () {
      api.rerender('0a7ac3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/org/components/org/ContactPane.vue"
export default component.exports